import CommonUiModel from "../common/commonUiModel";

const EquipmentFamily = new CommonUiModel({
    title: "Equipment",
    relations: ["Document"],
    permissions: { add: false, edit: true, delete: false },
    gridTitle: "Equipment Master",
    formTitle: "Equipment Master",
    module: "EquipmentMaster",
    showHistory: false,
    columns: [
        { field: 'EquipmentId', label: 'Primary Key', readOnly: true, type: 'number' },
        { field: 'ModelName', label: 'Equipment Model', readOnly: true },
        { field: 'EquipmentTypeId', label: 'Equipment Type', type: 'select', width: 200, lookup: 'equipmentType', readOnly: true, dataIndex: "EquipmentType" },
        { field: 'EquipmentFamilyId', label: 'Equipment Family', type: 'select', width: 200, lookup: 'EquipmentFamily', readOnly: true, dataIndex: "EquipmentFamily" },
        { field: 'DeviceType', label: 'Device Type', readOnly: true },
        { field: 'StatusId', label: 'Status', defaultValue: true, lookup: 'ScopeStatus', type: 'select', width: 150 },
        { field: 'HuluMachineFamilyId', label: 'HULU Machine Family Id', type: 'number', width: 200, readOnly: true, hide: true },
        { field: 'HuluMachineFamilyName', label: 'HULU Machine Family Name', readOnly: true, hide: true },
        { field: 'ParameterSetValues', label: 'Parameter Set Json', readOnly: true, hide: true },
        { field: 'Notes', label: 'Notes', multiline: true },
        { field: 'HULUMachineModelName', label: 'HULU Machine Model Name', readOnly: true, hide: true },
        { field: 'HULUMachineModelId', type: 'number', width: 200, label: 'HULU Machine Model ID', readOnly: true, hide: true },
        { field: 'HookupConfigValues', label: 'Connector Config Value', readOnly: true, hide: true },
        { field: 'MaxScopesPerBasin', type: 'number', width: 200, label: 'Max Scopes Per Basin', readOnly: true }
    ]
});

export default EquipmentFamily;